import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedDate } from 'react-intl';
import Stars from 'react-stars';

import { SingleReputationFragment } from '../../../../generated/graphql_offer';
import { toJSDate } from '../../../../graphql/datetime';
import { SPACING_UNIT } from '../../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../../styleUtility/gridLayout';
import mq from '../../../styleUtility/mediaquery';
import _AvatarAndName from '../AvatarAndName';

interface Props extends ClassAttributes<HTMLElement> {
  reputation: SingleReputationFragment;
  loadingReputation?: boolean;
  className?: string;
}

const ReputationItem = ({ reputation, className }: Props) => (
  <Root className={className}>
    <UserWithActions>
      <AvatarAndName user={reputation.evaluator} />
      <Score>
        <Stars edit={false} count={5} value={reputation.score} size={16} color2={'#1DA772'} />
      </Score>
    </UserWithActions>
    <Comment variant="body2">{reputation.comment}</Comment>
    <Date variant="caption">
      <FormattedDate
        value={toJSDate(reputation.updatedAt)}
        year="numeric"
        month="2-digit"
        day="2-digit"
        hour="2-digit"
        minute="2-digit"
      />
    </Date>
  </Root>
);

const Root = styled('div')(
  gridLayoutContainer({
    columns: ['auto'],
    rows: ['auto'],
    areas: [['userWithActions'], ['comment'], ['date']],
  }),
  {
    alignItems: 'center',
    paddingTop: SPACING_UNIT / 2,
    paddingBottom: SPACING_UNIT / 2,
  },
);

const UserWithActions = styled('div')(
  gridLayoutItem('userWithActions'),
  gridLayoutContainer({
    columns: ['auto', '8px', '80px', '1fr'],
    rows: ['auto'],
    areas: [['user', '.', 'score', 'button']],
    alignItems: 'center',
  }),
  {
    [mq('sp')]: {
      ...gridLayoutContainer({
        columns: ['1fr', 'auto'],
        rows: ['auto', 'auto'],
        areas: [
          ['user', 'button'],
          ['score', 'button'],
        ],
      }),
    },
  },
);

const AvatarAndName = styled(_AvatarAndName)({
  ...gridLayoutItem('user'),
});

const Score = styled('div')({
  ...gridLayoutItem('score'),
});

const Comment = styled(Typography)(gridLayoutItem('comment'), {
  marginTop: SPACING_UNIT,
  marginBottom: SPACING_UNIT / 2,
});

const Date = styled(Typography)(gridLayoutItem('date'));

export default ReputationItem;
